// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./app/auth/authConfig"; // MSAL instance
import Login from "./app/auth/SigninWidget"; // Your login component
import useAutoLogout from "./app/auth/AutoLogout";
import Details from "./pages/Details/Details";
import Application from "./pages/Application/Application";
import ToolDetails from "./pages/Details/ToolDetails";
import UserManagementPage from "./pages/AdminControl/UserManagementPage";
import CategoryManagementPage from "./pages/AdminControl/CategoryManagementPage";
import ToolManagementPage from "./pages/AdminControl/ToolManagementPage";
import NotificationManagementPage from "./pages/AdminControl/NotificationManagementPage";
import ToolReportDashboardPage from "./pages/AdminControl/ToolReportDashboardPage";
import PagesManager from "./pages/Pages/PagesManager";
import PageViewer from "./pages/Pages/PageViewer";
import ToolAppViewer from "./pages/Pages/ToolAppViewer";


const App = () => {
  useAutoLogout(); // Automatically logs out after 5 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} /> {/* Home route */}
          <Route path="/details-email" element={<Details />} /> {/* Home route */}
          <Route path="/application" element={<Application />} /> {/* Home route */}
          <Route path="/details/:id" element={<ToolDetails />} />
          <Route path="/admin/control/userManagement" element={<UserManagementPage />} /> 
          <Route path="/admin/control/toolManagement" element={<ToolManagementPage/>} /> 
          <Route path="/admin/control/categoryManagement" element={<CategoryManagementPage />} /> 
          <Route path="/admin/control/notificationmanagement" element={<NotificationManagementPage />} /> 
          <Route path="/tool/report/:reportnewid" element={<ToolReportDashboardPage />} />
          <Route path="/pages-manager" element={<PagesManager />} />
          <Route path="/pages/:filename" element={<PageViewer />} />
          <Route path="/tool/:toolName/*" element={<ToolAppViewer />} />
          <Route path="/tools/:toolName/*" element={<ToolAppViewer />} />
          <Route path="/staticTools/:toolName/*" element={<ToolAppViewer />} />
        </Routes>
      </Router>
    </MsalProvider>
  );
};

export default App;
